import React, { memo } from 'react';
const bonuses = [{
  label: '🎁 BONO 1',
  title: 'Contrato de Membresía y Deslinde Legal',
  desc: 'Ficha de inscripción, contrato firmable y cláusula de responsabilidad civil. Protegé tu dojo desde hoy.',
  price: '$4.990'
}, {
  label: '🎁 BONO 2',
  title: 'Agenda de 52 Semanas',
  desc: 'Plan técnico completo para todo el año. Nunca más improvisás qué enseñar en clase.',
  price: '$4.990'
}, {
  label: '🎁 BONO 3',
  title: 'Script Anti-Deserción',
  desc: 'Los mensajes exactos para recuperar alumnos que se están yendo. Listos para copiar y enviar.',
  price: '$3.990'
}, {
  label: '🎁 BONO 4',
  title: 'Planilla de Control de Cobros',
  desc: 'Sistema completo de gestión financiera. Sabés en todo momento quién pagó, quién debe y cuánto ganás.',
  price: '$3.990'
}, {
  label: '🎁 BONO 5',
  title: 'Calendario Editorial 30 Días',
  desc: '30 textos listos para publicar en Instagram y Facebook. Marketing orgánico sin gastar un peso.',
  price: '$3.990'
}, {
  label: '🎁 BONO 6',
  title: 'Guía de Seminarios de Fin de Semana',
  desc: 'El sistema para organizar eventos que generan hasta $200.000 pesos de ingreso extra en 2 días.',
  price: '$4.990'
}];
export function Bonuses() {
  return <section className="w-full px-4 py-8 text-base leading-6" style={{
    backgroundColor: 'rgb(22, 12, 30)',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
  }} data-id="element-40">
      <div className="mx-auto max-w-3xl" data-id="element-41">
        {/* TÍTULO */}
        <div className="mb-4 text-center" data-id="element-42">
          <p className="text-xs font-bold tracking-[2px] uppercase text-red-500 mb-1" data-id="element-43">
            🎁 Todo esto también es tuyo
          </p>
          <h2 className="text-2xl sm:text-3xl font-black leading-tight text-white m-0 mb-1" data-id="element-44">
            Más los{' '}
            <span className="text-red-500" data-id="element-45">6 Bonos de Implementación</span>
          </h2>
          <p className="text-xs text-gray-500 m-0" data-id="element-46">
            Incluidos en todas las ofertas — sin costo extra
          </p>
        </div>

        {/* BONOS GRID */}
        <div className="mb-5 grid grid-cols-2 lg:grid-cols-3 gap-2.5" data-id="element-47">
          {bonuses.map(bonus => <div key={bonus.label} className="flex flex-col rounded-lg p-3 shadow-sm" style={{
          backgroundColor: 'rgb(20, 5, 5)',
          border: '1px solid rgb(127, 29, 29)'
        }} data-id="element-48">
              {/* LABEL */}
              <div className="mb-1 text-[10px] font-bold uppercase tracking-[1px] text-red-500" data-id="element-49">
                {bonus.label}
              </div>

              {/* TÍTULO */}
              <h3 className="text-xs sm:text-sm font-black text-white m-0 mb-1 leading-tight" data-id="element-50">
                {bonus.title}
              </h3>

              {/* DESCRIPCIÓN */}
              <p className="flex-1 text-[11px] leading-snug text-gray-400 m-0 mb-2" data-id="element-51">
                {bonus.desc}
              </p>

              {/* PRECIO TACHADO + GRATIS */}
              <div className="flex items-center gap-1.5" data-id="element-52">
                <span className="text-[11px] text-gray-600 line-through" data-id="element-53">
                  {bonus.price}
                </span>
                <span className="bg-red-600 text-[9px] font-black text-white rounded-full px-1.5 py-0.5" data-id="element-54">
                  GRATIS
                </span>
              </div>
            </div>)}
        </div>

        {/* VALOR TOTAL DE LOS BONOS */}
        <div className="mx-auto max-w-xl text-center rounded-lg p-3.5 shadow-sm mb-5" style={{
        backgroundColor: 'rgb(20, 5, 5)',
        border: '1px solid rgba(196, 30, 58, 0.4)'
      }} data-id="element-55">
          <p className="text-[10px] font-semibold uppercase tracking-[1.4px] text-red-500 m-0 mb-0.5" data-id="element-56">
            Valor total de los 6 Bonos
          </p>
          <div className="flex items-center justify-center gap-2" data-id="element-57">
            <span className="text-sm text-gray-600 line-through" data-id="element-58">$26.950</span>
            <span className="text-sm sm:text-base font-black tracking-wide text-red-500" data-id="element-59">
              🎁 GRATIS — Incluidos siempre
            </span>
          </div>
        </div>

        {/* CTA */}
        <div className="text-center" data-id="element-60">
          <p className="text-xs text-gray-600 mt-1" data-id="element-61">
            🛡️ Garantía 7 días · ⚡ Acceso inmediato · 🔒 Pago seguro
          </p>
        </div>
      </div>
    </section>;
}